<template>
	<v-container class="d-flex flex-column" :class="smAndDown ? 'py-0 pb-0' : 'pa-16 '" fluid style="z-index: 1" :style="[store.theme === 'dark' ? 'background-color: black' : '', opacityStyle]">
		<div class="d-flex w-100">
			<stylized-title :size="3" :to="store.currentShowId && `/${store.currentShowId}`" />
			<v-spacer />
			<v-row class="w-50 text-end" :class="smAndDown ? 'text-start align-center' : ''">
				<v-spacer v-if="!smAndDown" />
				<v-col :cols="smAndDown ? 12 : 3" class="d-flex flex-column text-no-wrap">
					<router-link to="/upload?reset=1" class="mb-2"><span :class="store.theme === 'dark' ? 'text-white' : 'text-red-darken-4'">Show Yourself</span></router-link>
					<v-spacer />
				</v-col>
			</v-row>
		</div>
		<v-divider :class="smAndDown ? 'mb-4' : 'mt-16 mb-8'" thickness="2" />
		<div class="d-flex align-center mb-16" :style="smAndDown ? 'font-size: smaller' : ''" :class="smAndDown ? 'text-no-wrap' : ''">
			<div class="d-flex align-center"><span class="copyright mr-1">©</span>2026</div>
			<v-spacer />
			<div class="font-italic font-weight-light">{{ t(`nav.happyGraduation${smAndDown ? 'Mobile' : ''}`) }}</div>
		</div>
	</v-container>
</template>
<style scoped>
a {
	text-decoration: none;
	color: black;
}
.copyright {
	font-family: 'roboto';
	font-size: 1rem;
}
</style>
<script setup>
import { ref, computed, onMounted, inject } from 'vue'
import { useDisplay } from 'vuetify/lib/framework.mjs'
import StylizedTitle from '@/components/StylizedTitle.vue'
import { useTranslation } from 'i18next-vue'
import { useAppStore } from '@/store/app'

const $emitter = inject('$emitter')
const fontsLoaded = ref(false)
const store = useAppStore()
const { t } = useTranslation()
const { smAndDown } = useDisplay()
const playState = ref()

const opacityStyle = computed(() => {
    if (!fontsLoaded.value) {
        return 'opacity: 0'
    }
    if (playState.value === 'playing') {
        return 'opacity: 0.2'
    }
    return 'opacity: 0.9'
})

$emitter.on('playState', value => {
    if (!value) return
    playState.value = value
})

onMounted(async () => {
	await document.fonts.ready
	fontsLoaded.value = true
})
</script>
